import { FC } from 'react';
import EditorLink from 'lowcode/components/EditorLink';
import ProductHeader from '../ProductHeader';
import styled from './index.module.scss';
import { useProductList } from '@/components/MembersDay/utils';
import { IProductProps } from '@/components/MembersDay/type';
import getLocal from '@/app/utils/getLocal';
import { useLang } from '@/i18n';
import BigCard from './BigCard';

const Horizonta: FC<IProductProps> = ({ module, icon, title, desc, id }) => {
    const { t } = useLang('membersday.activity');
    const { locale } = getLocal();
    const { productList } = useProductList(module, locale);

    if (!productList || productList.length < 0) return <></>;

    return (
        <div className={`${styled.Horizonta}`} id="activity-HotBundles1">
            <ProductHeader icon={icon} title={title} desc={desc} />
            <div className="list_box">
                {productList.map((item, index) => (
                    <BigCard key={item.variantId} title={title} data={item} left={index % 2 === 1} entry_position={5} />
                ))}
            </div>
        </div>
    );
};

export default Horizonta;
